export interface Project {
  id: string
  name: string
  description: string
  status: 'active' | 'development' | 'planned'
  icon: string
  gradientFrom: string
  gradientTo: string
  href: string
  features: string[]
  tech: string[]
}

export const projects: Project[] = [
  {
    id: 'family-finance',
    name: 'Finances',
    description:
      'Comprehensive family financial hub — synced accounts, investments with tax treatment, budgets, bill reminders, tax document vault with CPA sharing, and P&L + return tracking for every business entity.',
    status: 'development',
    icon: '💰',
    gradientFrom: '#8b5cf6',
    gradientTo: '#6366f1',
    href: '/dashboard/family-finance',
    features: [
      'Linked institutions with registered read-only access',
      'Tax document hub, estimated return & CPA shared folder',
      'Bill alerts and email reminders',
      'OBFH, IRPM, NB Law, SB Tax & Lawdiem entity panels',
    ],
    tech: ['React', 'AWS Lambda', 'DynamoDB', 'S3', 'SES', 'Plaid'],
  },
  {
    id: 'nventures',
    name: 'NVentures',
    description:
      'Web design, development & hosting studio — custom sites and web apps for small businesses and professional practices, built end-to-end and hosted on AWS. Four production builds live today, from brand sites to full practice-management software.',
    status: 'active',
    icon: '🌐',
    gradientFrom: '#ec4899',
    gradientTo: '#14b8a6',
    href: '/dashboard/nventures',
    features: [
      'lawdiem.com — software for the practice of law',
      'easytaxprotest.com — Texas property tax protest service',
      'ironrockproperties.com — Central Texas property management',
      'hertabrand — salon & beauty-educator brand site',
    ],
    tech: ['Next.js', 'React', 'Tailwind', 'AWS Amplify', 'Route 53', 'Lambda'],
  },
  {
    id: 'family-planner',
    name: 'Family Planner',
    description:
      'One family calendar built from every Google and Microsoft account, plus events pulled out of Gmail invitations and watched WhatsApp threads — with getaway windows, last-minute flight and cruise deals, and an assistant that answers questions about the schedule.',
    status: 'development',
    icon: '🗓️',
    gradientFrom: '#14b8a6',
    gradientTo: '#0ea5e9',
    href: '/dashboard/family-planner',
    features: [
      'Google & Microsoft calendars merged into one view',
      'Gmail invites and WhatsApp plans parsed into a review inbox',
      'Conflict detection and open getaway windows',
      'Deal watch on preselected destinations + planning assistant',
    ],
    tech: ['React', 'AWS Lambda', 'DynamoDB', 'Google Calendar API', 'Microsoft Graph', 'Claude Opus 5'],
  },
  {
    id: 'watch-monitor',
    name: 'Watch Monitor',
    description:
      'Automated watch listing alert system monitoring 13+ marketplaces with email notifications when catalog watches appear for sale.',
    status: 'active',
    icon: '⌚',
    gradientFrom: '#f59e0b',
    gradientTo: '#ea580c',
    href: '/dashboard/watch-monitor',
    features: [
      'Live sources: Reddit, eBay & Watchrecon',
      'AWS SES email alerts 4x daily',
      'DynamoDB deduplication',
      'Editable catalog from the dashboard',
    ],
    tech: ['Python', 'AWS Lambda', 'DynamoDB', 'SES', 'EventBridge'],
  },
  {
    id: 'financial-app',
    name: 'Securities Research',
    description:
      'Full securities research suite — vol-divergence screener, unsupervised marker-influence lab (options, X trends, macro, Fama–French), convertible/preferred parity scanner priced off the options chain, Monte Carlo strategy simulation, idea tracking, SEC filings browser, and an Opus 5 analyst.',
    status: 'development',
    icon: '📊',
    gradientFrom: '#10b981',
    gradientTo: '#0d9488',
    href: '/dashboard/financial-app',
    features: [
      'Screen equities by short-term vol divergence, per sector',
      'Marker Lab: PCA + influence ranking across options, X, macro & Fama–French markers',
      'Convertible & preferred parity scanner priced against the listed chain',
      'Monte Carlo lab: outcome bell curve and ±20% sensitivity tornado',
      'Idea tracker with earnings dates and latest filings',
      'Opus 5 filing analysis: offerings, converts, preferred clauses',
    ],
    tech: ['React', 'AWS Lambda', 'DynamoDB', 'yfinance', 'Claude Opus 5'],
  },
  {
    id: 'fantasy-football',
    name: 'Fantasy Football',
    description:
      'Draft and roster optimizer for connected Yahoo & ESPN leagues — consensus projections with covariance-aware risk adjustments (shared teams, shared byes), schedule strength, and win-maximizing draft orders backed by an auditable formula knowledge base.',
    status: 'development',
    icon: '🏈',
    gradientFrom: '#0ea5e9',
    gradientTo: '#6366f1',
    href: '/dashboard/fantasy-football',
    features: [
      'Yahoo & ESPN league connections with live sync',
      'Risk-adjusted player values with correlation penalties',
      'User-approved draft orders with scarcity weighting',
      'Every formula documented, tunable, and audit-logged',
    ],
    tech: ['React', 'AWS Lambda', 'DynamoDB', 'Yahoo API', 'ESPN API'],
  },
]
